export default __webpack_public_path__ + "static/media/homepage1.4f5ec694.jpg";